import { render, staticRenderFns } from "./SecondStep.vue?vue&type=template&id=65af0f7e&"
import script from "./SecondStep.vue?vue&type=script&lang=js&"
export * from "./SecondStep.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports